module.exports = __webpack_public_path__ + "img/quanfangwei.6dcdff82.png";